module.exports = __webpack_public_path__ + "img/php.1286e4eb.png";